import {ProcessFlowchartNodeDetailsType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {
  ProcessFlowchartNodeAdapter,
  ProcessFlowchartTaskSchemaNodeAdapter,
} from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/nodes/ProcessFlowchartNodeAdapter';
import {PLUGIN_REGISTRY_INSTANCE} from 'processes/graph-builder-processes/platform/PluginRegistry';

import {
  FlowchartNode,
  isInteractiveTaskNode,
  isStaticPlaceholderNodeData,
  isStaticTaskSchemaNodeData,
  StaticFlowchartNodeData,
} from './processFlowchartConfigEditorNodeTypes';

export function getAdapterForNode(
  node: FlowchartNode | null
): ProcessFlowchartTaskSchemaNodeAdapter<unknown, unknown> | ProcessFlowchartNodeAdapter | null {
  return getAdapterForNodeData(node?.data ?? null);
}

export function getAdapterForNodeData(
  nodeData: StaticFlowchartNodeData | null
): ProcessFlowchartTaskSchemaNodeAdapter<unknown, unknown> | ProcessFlowchartNodeAdapter | null {
  if (nodeData == null) {
    return null;
  }
  if (isStaticTaskSchemaNodeData(nodeData)) {
    return PLUGIN_REGISTRY_INSTANCE.getTaskSchemaNodeAdapter(
      nodeData.taskDefinitionVersionSpec.newProcessTaskDefinitionVersion.taskSchema.executionType
    );
  }
  if (isStaticPlaceholderNodeData(nodeData)) {
    return null;
  }
  return PLUGIN_REGISTRY_INSTANCE.getNodeAdapter(nodeData.nodeType);
}

export function getAdapterForTaskSchemaNode(
  node: FlowchartNode | null
): ProcessFlowchartTaskSchemaNodeAdapter<unknown, unknown> | null {
  if (node && isInteractiveTaskNode(node)) {
    return PLUGIN_REGISTRY_INSTANCE.getTaskSchemaNodeAdapter(
      node.data.taskDefinitionVersionSpec.newProcessTaskDefinitionVersion.taskSchema.executionType
    );
  }
  return null;
}

export function isStartOrEndNode(nodeDetailsType: ProcessFlowchartNodeDetailsType): boolean {
  return (
    nodeDetailsType === ProcessFlowchartNodeDetailsType.ROOT_NODE_DETAILS ||
    nodeDetailsType === ProcessFlowchartNodeDetailsType.OUTPUT_NODE_DETAILS
  );
}

export function isNodeDeletable(
  node: FlowchartNode,
  options?: {allowStartEndNodeDeletion?: boolean}
): boolean {
  if (
    options?.allowStartEndNodeDeletion &&
    isInteractiveTaskNode(node) &&
    isStartOrEndNode(node.data.nodeDetailsType)
  ) {
    return true;
  }
  const adapter = getAdapterForNode(node);
  if (adapter == null) {
    return true;
  }
  return adapter.isDeletable();
}
